<template>
  <div class="wrapper" style="width: 100%;margin-top:20px;">
      <div style="width: 25%;">
          <div style="display: flex;justify-content: end">
              <SidebarMenu sidebarTitle="气象信息" :menu-list="menuList" :active-menu="activeMenu"  @menu-click="handleMenuClick" />
          </div>
      </div>
      <div style="width: 2%;"> </div>
      <div style="width: 78%;padding: 0 2rem 0 0;">
          <div class="content-header">
              <h1 class="content-title">{{ currentMenuTitle }}</h1>
              <p class="content-subtitle">{{ currentMenuDesc }}</p>
          </div>
          <div class="weather-content">
              <Weather v-if="active === 'weather'" />
              <Cloud v-if="active === 'cloud'" />
              <Rain v-if="active === 'rain'" />
              <Radar v-if="active === 'radar'" />
          </div>
      </div>
  </div>
</template>

<script>
import Cloud from "./components/cloud";
import Rain from "./components/rain";
import Radar from "./components/radar";
import Weather from "./components/weather";
import SidebarMenu from "@/components/water-affairs-style/sidebarMenu.vue";
export default {
  components: {
    Cloud,
    Rain,
    Weather,
    Radar,
    SidebarMenu
  },
  computed: {
      currentMenuTitle() {
          const menu = this.menuList.find(m => m.key === this.activeMenu);
          return menu ? menu.title : '基础设置';
      },
      currentMenuDesc() {
          const menu = this.menuList.find(m => m.key === this.activeMenu);
          return menu ? menu.desc : '配置系统基本参数和运行环境';
      }
  },
  data() {
    return {
      active: "weather",
        activeMenu: 'weather',
        menuList: [
            { key: 'weather', title: '天气预报', icon: '☀️', desc: '24小时与一周天气预报',path:'weather' },
            { key: 'rain', title: '短时降雨', icon: '🌧️', desc: '2小时雨量预报',path:'rain' },
            { key: 'cloud', title: '卫星云图', icon: '🌐', desc: '卫星云图信息',path:'cloud' },
            { key: 'radar', title: '雷达信息', icon: '🔐', desc: '雷达信息展示',path:'radar' },
        ]
    };
  },
  methods: {
      handleMenuClick(menuKey) {
          this.activeMenu = menuKey;
          this.active = menuKey;
      }
  }
};
</script>



<style lang="less" scoped>
.wrapper{
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  height: 100%;
  width: 100%;
  padding: 10px;
  box-sizing: border-box;
    .content-title{
        font-size: 1.8rem;
        font-weight: bold;
        background: linear-gradient(135deg, #fff, #00ff96);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        margin-bottom: 0.5rem;
    }
    .content-subtitle{
        color: #64748b;
        font-size: 0.95rem;
    }
    .weather-content{
        background: rgba(20, 35, 70, 0.5);
        //backdrop-filter: blur(10px);
        border: 1px solid rgba(0, 255, 150, 0.2);
        border-radius: 16px;
        padding: 2rem;
        margin-bottom: 1.5rem;
    }
}
</style>